// src/hooks/useScrollVisibility.ts
import { useState, useEffect, useRef } from 'react';

export function useScrollVisibility(threshold = 10): boolean {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    const mainElement = document.querySelector('main');
    if (!mainElement) return;

    const handleScroll = () => {
      const scrollTop = mainElement.scrollTop;
      
      if (scrollTop > lastScrollTop.current && scrollTop > threshold) {
        setIsVisible(false);
      } else if (scrollTop < lastScrollTop.current) {
        setIsVisible(true);
      }
      
      lastScrollTop.current = scrollTop;
    };

    mainElement.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      mainElement.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]); 

  return isVisible;
}